// Token reward ranges by rarity and times opened
export const TOKEN_REWARDS = {
  Common: {
    baseRange: { min: 1, max: 5 },
    multiplier: [1, 0.8, 0.6, 0.4, 0.2], // Multipliers for each time opened (0-4)
  },
  Uncommon: {
    baseRange: { min: 10, max: 20 },
    multiplier: [1, 0.8, 0.6, 0.4, 0.2],
  },
  Rare: {
    baseRange: { min: 30, max: 60 },
    multiplier: [1, 0.8, 0.6, 0.4, 0.2],
  },
  Epic: {
    baseRange: { min: 90, max: 180 },
    multiplier: [1, 0.8, 0.6, 0.4, 0.2],
  },
  Legendary: {
    baseRange: { min: 270, max: 360 },
    multiplier: [1, 0.8, 0.6, 0.4, 0.2],
  },
} as const

export const INITIAL_RARITY_CHANCES = {
  Common: 0.45,
  Uncommon: 0.24,
  Rare: 0.16,
  Epic: 0.1,
  Legendary: 0.05,
}

// Forge success chance by rarity
export const FORGE_SUCCESS_RATES = {
  Common: 0.8, // 80% success rate
  Uncommon: 0.7,
  Rare: 0.6,
  Epic: 0.45,
  Legendary: 0.3,
} as const

// Token costs for forging by rarity
export const FORGE_TOKEN_COSTS = {
  Common: 20,
  Uncommon: 120,
  Rare: 600,
  Epic: 2400,
  Legendary: 7200,
} as const

// Required cards for forging by rarity
export const FORGE_REQUIRED_CARDS = {
  Common: 5,
  Uncommon: 4,
  Rare: 3,
  Epic: 3,
} as const

// Same as top, has no chance to modify, remember to sync
export const FORGE_RULES = {
  Common: { required: 5 },
  Uncommon: { required: 4 },
  Rare: { required: 3 },
  Epic: { required: 3 },
}

// Rarity upgrade mapping
export const RARITY_LEVELS = [
  'Common',
  'Uncommon',
  'Rare',
  'Epic',
  'Legendary',
  'Original',
] as const

export const RARITY_ORDER = {
  Original: 6,
  Legendary: 5,
  Epic: 4,
  Rare: 3,
  Uncommon: 2,
  Common: 1,
}
